import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { ProfileMinimized } from "PFTypes/profile";
import { Link } from "react-router";

import css from "./chat.module.scss";

type ChatHeaderOpenTitleProps = {
  title: string;
  targetUrl: string | false;
  otherPerson: ProfileMinimized | null;
};

export const ChatHeaderOpenTitle = ({ title, targetUrl, otherPerson }: ChatHeaderOpenTitleProps) => (
  <Link to={targetUrl || ""} className={css.wrapper}>
    {otherPerson && <ProfileAvatar profile={otherPerson} size={22} />}
    <div className={css.titleName}>{title}</div>
  </Link>
);
